module.exports = __webpack_public_path__ + "static/media/OntheBrightSide_Bookcover.b61a2a17.jpg";